import styled from "@emotion/styled";
import { Close } from "../../icons/Close";
import { level25 } from "../../../other/theme/opacities";
import { IconButton } from "../../iconButton";

interface IProps {
    disableMaxWidth?: boolean;
    closeCallback: () => void;
    children: React.ReactNode;
    testId: string;
}
interface IContainerProps {
    disableMaxWidth?: boolean;
}

export const DialogShape = (props: IProps) => {
    return (
        <Container
            data-testid={props.testId}
            disableMaxWidth={props.disableMaxWidth}
        >
            <CloseButton>
                <IconButton
                    icon={Close}
                    onClick={props.closeCallback}
                    testId="dialogCloseButton"
                />
            </CloseButton>
            {props.children}
        </Container>
    );
};

const Container = styled("div")<IContainerProps>(props => ({
    display: "inline-block",
    minWidth: 300,
    borderRadius: "3px",
    overflow: "hidden",
    position: "relative",
    padding: "26px 34px 20px 34px",
    boxShadow: `4px 4px 20px ${props.theme.shadow + level25}`,
    backgroundColor: props.theme.background1,
    ...(!props.disableMaxWidth && { maxWidth: 600 })
}));

const CloseButton = styled("div")({
    position: "absolute",
    padding: 0,
    border: 0,
    top: 5,
    right: 5,
    opacity: 0.4
});
